import api from "../utils/api";

// ─── Analytics ────────────────────────────────────────────────────────────────

/**
 * GET /web/v1/analytics/payment-requests?from=:from&to=:to
 *
 * Returns payment-request analytics for the given date range.
 * @param {string} from  — ISO date string YYYY-MM-DD
 * @param {string} to    — ISO date string YYYY-MM-DD
 *
 * Response envelope:
 * {
 *   "status": 200,
 *   "message": "Success",
 *   "data": {
 *     "overDueCount": 4,
 *     "outStanding": { "currency": "USD", "count": 7, "amount": 33.69 },
 *     "paid": { "count": 12, "amount": 10.91, "currency": "USD" },
 *     "open": { "count": 7, "amount": 33.69, "currency": "USD" }
 *   }
 * }
 */
export const getPaymentRequestAnalytics = async ({ from, to } = {}) => {
    const res = await api.get("/web/v1/analytics/payment-requests", {
        params: { from, to },
    });
    return res.data;
};

/**
 * GET /web/v1/analytics/transactions?from=:from&to=:to
 *
 * Returns transaction analytics for the given date range.
 * @param {string} from  — ISO date string YYYY-MM-DD
 * @param {string} to    — ISO date string YYYY-MM-DD
 *
 * Response envelope:
 * {
 *   "status": 200,
 *   "message": "Success",
 *   "data": {
 *     "life": {
 *       "pending":  { "count": 3, "data": [{ "currency": "USD", "count": 3, "amount": "3.2" }] },
 *       "success":  { "count": 69, "data": [...] },
 *       "rejected": { "count": 16, "data": [...] },
 *       "failed":   { "count": 1, "data": [...] },
 *       "created":  { "count": 14, "data": [...] }
 *     },
 *     "mtd": {
 *       "success": { "count": 3, "data": [...] },
 *       "failed":  { "count": 1, "data": [...] }
 *     }
 *   }
 * }
 */
export const getTransactionAnalytics = async ({ from, to } = {}) => {
    const res = await api.get("/web/v1/analytics/transactions", {
        params: { from, to },
    });
    return res.data;
};

/**
 * GET /web/v1/analytics/vault/ledger
 *
 * Returns vault ledger analytics, broken down per currency.
 *
 * Response envelope:
 * {
 *   "status": 200,
 *   "message": "Success",
 *   "data": [
 *     {
 *       "currency": "USDT",
 *       "amount": "17666.88",
 *       "count": 56,
 *       "net": 0,
 *       "inCount": 28,
 *       "inAmount": "8833.44",
 *       "outCount": 28,
 *       "outAmount": "8833.44"
 *     },
 *     { "currency": "USDC", ... }
 *   ]
 * }
 */
export const getVaultLedgerAnalytics = async ({ from, to } = {}) => {
    const res = await api.get("/web/v1/analytics/vault/ledger", {
        params: { from, to },
    });
    return res.data;
};
